'use client'

import { useState } from 'react'

export default function InteractiveWidgetMock() {
  const [name, setName] = useState('Emma')
  const [age, setAge] = useState('30')
  const [activeTab, setActiveTab] = useState(0)
  const [focusedField, setFocusedField] = useState<'name' | 'age' | null>('name')

  const inputBaseStyle: React.CSSProperties = {
    width: '100%',
    padding: '6px 8px',
    fontSize: 11,
    borderRadius: 6,
    marginTop: 2,
    background: '#fff',
    color: '#111',
    fontFamily: 'inherit',
    outline: 'none',
    boxSizing: 'border-box',
  }

  return (
    <div style={{ background: '#f8f8ff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, overflow: 'hidden' }}>
      <div style={{ padding: '12px 14px' }}>
        {/* Tabs */}
        <div style={{ display: 'flex', borderBottom: '2px solid #f0f0f0', marginBottom: 10 }}>
          {['Front', 'Back'].map((t, i) => {
            const active = i === activeTab
            return (
              <button
                type="button"
                key={t}
                onClick={() => setActiveTab(i)}
                style={{
                  padding: '8px 10px 7px',
                  fontSize: 11,
                  fontWeight: active ? 600 : 500,
                  color: active ? '#4f46e5' : '#9ca3af',
                  borderBottom: `2px solid ${active ? '#4f46e5' : 'transparent'}`,
                  marginBottom: -2,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                  background: 'transparent',
                  border: 'none',
                  borderBottomWidth: 2,
                  borderBottomStyle: 'solid',
                  borderBottomColor: active ? '#4f46e5' : 'transparent',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                <span style={{
                  width: 13, height: 13, borderRadius: '50%',
                  background: active ? '#4f46e5' : 'transparent',
                  color: active ? '#fff' : '#9ca3af',
                  border: active ? 'none' : '1px solid #d1d5db',
                  fontSize: 8, fontWeight: 700,
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                }}>{i + 1}</span>
                {t}
              </button>
            )
          })}
        </div>

        {/* Live preview — reflects what's typed */}
        <div
          style={{
            background: '#e8e9ed',
            borderRadius: 6,
            height: 96,
            marginBottom: 10,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 12px',
            overflow: 'hidden',
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: 6,
              left: 8,
              fontSize: 8,
              fontFamily: "'IBM Plex Sans', sans-serif",
              letterSpacing: '0.14em',
              color: '#4f46e5',
              background: '#fff',
              padding: '2px 5px',
              borderRadius: 2,
            }}
          >
            ● LIVE PREVIEW
          </span>
          {activeTab === 0 ? (
            <>
              <span
                style={{
                  fontFamily: "'Instrument Serif', ui-serif, Georgia, serif",
                  fontStyle: 'italic',
                  fontSize: 26,
                  letterSpacing: '-0.02em',
                  color: '#141414',
                  lineHeight: 1.05,
                  textAlign: 'center',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {name.trim() || <span style={{ color: '#9ca3af' }}>Type a name…</span>}
              </span>
              {age.trim() && (
                <span
                  style={{
                    marginTop: 4,
                    fontSize: 10,
                    fontFamily: "'IBM Plex Sans', sans-serif",
                    letterSpacing: '0.18em',
                    textTransform: 'uppercase',
                    color: '#52525B',
                    fontWeight: 600,
                  }}
                >
                  Age {age.trim()}
                </span>
              )}
            </>
          ) : (
            <span style={{ fontSize: 11, color: '#9ca3af' }}>— back of product —</span>
          )}
        </div>

        {/* Editable fields */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div>
            <label htmlFor="docs-mock-name" style={{ fontSize: 10, color: '#374151', fontWeight: 500 }}>
              Name
            </label>
            <input
              id="docs-mock-name"
              type="text"
              value={name}
              maxLength={24}
              onChange={(e) => setName(e.target.value)}
              onFocus={() => setFocusedField('name')}
              onBlur={() => setFocusedField(null)}
              style={{
                ...inputBaseStyle,
                border: `1.5px solid ${focusedField === 'name' ? '#4f46e5' : '#d1d5db'}`,
              }}
            />
          </div>
          <div>
            <label htmlFor="docs-mock-age" style={{ fontSize: 10, color: '#374151', fontWeight: 500 }}>
              Age
            </label>
            <input
              id="docs-mock-age"
              type="text"
              inputMode="numeric"
              value={age}
              maxLength={3}
              onChange={(e) => setAge(e.target.value.replace(/[^0-9]/g, ''))}
              onFocus={() => setFocusedField('age')}
              onBlur={() => setFocusedField(null)}
              style={{
                ...inputBaseStyle,
                border: `1.5px solid ${focusedField === 'age' ? '#4f46e5' : '#d1d5db'}`,
              }}
            />
          </div>
        </div>

        <button
          type="button"
          style={{
            marginTop: 10,
            width: '100%',
            background: '#4f46e5',
            color: '#fff',
            fontWeight: 600,
            fontSize: 11,
            padding: '9px 10px',
            borderRadius: 6,
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Add to cart — $18.00
        </button>
      </div>
    </div>
  )
}
